/*
 * Schoonmaatje cadeaubalk
 * - Voegt automatisch de gratis cadeaus toe / haalt ze weg (regels met eigenschap _gift)
 * - Houdt de balk(en) live bij
 * Stappen: €25 vaatdoek, €41 glasdoek, €50 gratis verzending
 */
(function () {
  if (window.__giftBarLoaded) return;
  window.__giftBarLoaded = true;

  var T1 = 2500, T2 = 4100, T3 = 5000;
  var V1 = 68017469915445; // cadeau vaatdoek
  var V2 = 68017469948213; // cadeau glasdoek
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var syncing = false;
  var queued = false;
  var nativeFetch = window.fetch.bind(window);

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function isGift(item) {
    return item.properties && item.properties._gift;
  }

  function cartTotal(cart) {
    return cart.items.reduce(function (sum, item) {
      return isGift(item) ? sum : sum + item.final_line_price;
    }, 0);
  }

  function renderBars(total) {
    document.querySelectorAll('gift-bar').forEach(function (bar) {
      var pct = Math.min(100, (total / T3) * 100);
      var fill = bar.querySelector('[data-gift-fill]');
      if (fill) fill.style.width = pct + '%';

      var msg = bar.querySelector('[data-gift-msg]');
      if (msg) {
        if (total < T1) msg.innerHTML = 'Nog <strong>' + money(T1 - total) + '</strong> voor een GRATIS vaatdoek 😍';
        else if (total < T2) msg.innerHTML = 'Nog <strong>' + money(T2 - total) + '</strong> voor een GRATIS glasdoek 😍';
        else if (total < T3) msg.innerHTML = 'Nog <strong>' + money(T3 - total) + '</strong> voor GRATIS verzending 🚚';
        else msg.innerHTML = 'Top! Je krijgt 2 cadeaus + gratis verzending 🎉';
      }

      var badge = bar.querySelector('[data-gift-badge]');
      if (badge) {
        badge.hidden = total < T1;
        badge.textContent = total >= T2 ? 'Vaatdoek + glasdoek cadeau 🎁' : 'Vaatdoek cadeau t.w.v. €5,99 🎁';
      }

      [[1, T1], [2, T2], [3, T3]].forEach(function (s) {
        var el = bar.querySelector('[data-step="' + s[0] + '"]');
        if (el) el.classList.toggle('is-reached', total >= s[1]);
      });
      bar.setAttribute('data-total', total);
    });
  }

  function post(url, body) {
    return nativeFetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Gift-Bar': '1' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function getCart() {
    return nativeFetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Ververs de winkelwagenpagina en de rest van het thema na een cadeau-wijziging
  function refreshTheme(cart) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    var section = document.querySelector('.shopify-section--main-cart');
    if (!section || !section.id) return;
    var sectionId = section.id.replace('shopify-section-', '');
    nativeFetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(section.id) || doc.querySelector('.shopify-section--main-cart');
        if (fresh) section.innerHTML = fresh.innerHTML;
      })
      .catch(function () { window.location.reload(); });

    document.querySelectorAll('cart-count').forEach(function (el) { el.textContent = cart.item_count; });
  }

  function sync() {
    if (syncing) { queued = true; return; }
    syncing = true;

    getCart().then(function (cart) {
      var total = cartTotal(cart);
      renderBars(total);

      var want = {};
      want[V1] = total >= T1;
      want[V2] = total >= T2;

      var updates = {};   // line key -> quantity
      var have = {};
      var toAdd = [];

      cart.items.forEach(function (item) {
        if (item.variant_id !== V1 && item.variant_id !== V2) return;
        if (!isGift(item) || !want[item.variant_id] || have[item.variant_id]) {
          updates[item.key] = 0; // weg: niet (meer) verdiend, dubbel, of zonder cadeau-label
        } else {
          have[item.variant_id] = true;
          if (item.quantity !== 1) updates[item.key] = 1;
        }
      });

      [V1, V2].forEach(function (v) {
        if (want[v] && !have[v]) toAdd.push({ id: v, quantity: 1, properties: { _gift: '1' } });
      });

      var chain = Promise.resolve();
      var changed = false;
      if (Object.keys(updates).length) {
        changed = true;
        chain = chain.then(function () { return post('cart/update.js', { updates: updates }); });
      }
      if (toAdd.length) {
        changed = true;
        chain = chain.then(function () { return post('cart/add.js', { items: toAdd }); });
      }

      return chain.then(function () {
        if (!changed) return;
        return getCart().then(function (fresh) {
          renderBars(cartTotal(fresh));
          refreshTheme(fresh);
        });
      });
    }).catch(function (e) {
      console.warn('[gift-bar]', e);
    }).finally(function () {
      syncing = false;
      if (queued) { queued = false; setTimeout(sync, 150); }
    });
  }

  // Luister mee met alle winkelwagen-wijzigingen (thema én apps)
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var own = init && init.headers && (init.headers['X-Gift-Bar'] || (init.headers.get && init.headers.get('X-Gift-Bar')));
    var p = nativeFetch(input, init);
    if (!own && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
      p.then(function () { setTimeout(sync, 250); }, function () {});
    }
    return p;
  };

  ['cart:change', 'variant:add', 'line-item:change'].forEach(function (evt) {
    document.addEventListener(evt, function () { if (!syncing) setTimeout(sync, 250); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
